import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Bookpage } from '@pcp/core/interfaces';
import { NgClass } from '@angular/common';
import { CrossoriginImageDirective } from 'shared/ui/directives';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-bookpage-list',
    templateUrl: './bookpage-list.component.html',
    styleUrls: ['./bookpage-list.component.scss'],
    imports: [NgClass, CrossoriginImageDirective, TranslocoPipe]
})
export class BookpageListComponent {
    @Input() public bookpages: Bookpage[];
    @Output() public openBookpage = new EventEmitter<Bookpage>();
    @Output() public selectBookpage = new EventEmitter<Bookpage>();
    @Input() selectedPage: null | Bookpage = null;

    public get bookName() {
        const firstPage = this.bookpages[0];
        if (!firstPage) {
            throw new Error("'bookpages' property must not be empty.");
        }
        return firstPage.book;
    }

    public onBookpageDoubleClicked(page: Bookpage) {
        this.openBookpage.emit(page);
    }

    public onBookpageClicked(page: Bookpage) {
        this.selectBookpage.emit(page);
    }

    public getClass(page: Bookpage) {
        return { selected: page === this.selectedPage };
    }
}
